import type { Invoice } from '~/storage/types'

export class InvoiceSearchService {
    /**
     * Builds a searchable string from invoice metadata fields
     */
    private buildSearchString(invoice: Invoice): string {
        const metadata = invoice.metadata
        const fields: string[] = [
            metadata.reason ?? '',
            metadata.vendorName ?? '',
            metadata.amount.toString(),
            metadata.invoiceId ?? '',
            metadata.date.toString(),
        ]

        return fields
            .map((field) => field.toLowerCase().trim())
            .filter((field) => field.length > 0)
            .join(' ')
    }

    /**
     * Searches invoices by query string
     * Returns array of invoice IDs that match the query
     */
    search(invoices: Record<string, Invoice>, query: string): string[] {
        if (!query.trim()) {
            return Object.keys(invoices)
        }

        const searchTerms = query.toLowerCase().trim().split(/\s+/)
        const results: string[] = []

        for (const [invoiceId, invoice] of Object.entries(invoices)) {
            const searchString = this.buildSearchString(invoice)
            const matches = searchTerms.every((term) =>
                searchString.includes(term),
            )

            if (matches) {
                results.push(invoiceId)
            }
        }

        return results
    }
}
